import { render } from "./LogHistory.vue?vue&type=template&id=e241737e"
import script from "./LogHistory.vue?vue&type=script&lang=js"
export * from "./LogHistory.vue?vue&type=script&lang=js"

import "./LogHistory.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__